/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * @flow
 */
import {AbstractCrudObject} from './../abstract-crud-object';

/**
 * ReadOnlyAnalyticsUserPropertyConfig
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */
export default class ReadOnlyAnalyticsUserPropertyConfig extends AbstractCrudObject {
  static get Fields () {
    return Object.freeze({
      active_properties: 'active_properties',
      id: 'id',
    });
  }


  
  get (fields: Array<string>, params: Object = {}): ReadOnlyAnalyticsUserPropertyConfig {
    // $FlowFixMe : Support Generic Types
    return this.read(
      fields,
      params
    );
  }
}
